<template>
  <a-form layout="vertical" :model="filters">
    <a-form-item label="ФИО">
      <a-input v-model:value="filters.name" placeholder="Фио"/>
    </a-form-item>

    <a-form-item label="Группа">
      <a-select
          v-model:value="filters.groups"
          mode="multiple"
          :placeholder="'Не выбрано'"
          :not-found-content="'Нет данных'"
      >
        <a-select-option v-for="e in groups" :key="e.id" :value="e.id">
          {{ e.name }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item label="Совпадение с профилем, %">
      <div class="range-fields">
        <a-input
            v-model:value="filters.level_from"
            placeholder="от"
            inputmode="numeric"
        />

        <a-input
            v-model:value="filters.level_to"
            placeholder="до"
            inputmode="numeric"
        />
      </div>
    </a-form-item>

    <a-row justify="end" :gutter="8">
      <a-col>
        <a-button :class="'secondary-button'" @click="closeForm">Отменить</a-button>
      </a-col>
      <a-col>
        <a-button :class="'primary-button'" @click="updateFilters">Применить</a-button>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import {onBeforeMount, reactive, ref, watch} from "@vue/runtime-core";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";
import {toRaw} from "vue";

export default {
  props: {
    currentGroupId: [Number, String],
  },
  emits: ['close'],
  setup(props, context) {
    const currentFiltersLine = ref('')
    const store = useStore()

    const groups = computed(() => store.state.group.groups)
    const storedFilters = computed(() => store.state.users.filters)

    const makeLocalFilters = (source = {}) => ({
      name: source.name ?? '',
      job_title: source.job_title ?? '',
      department: source.department ?? '',
      online_from: source.online_from ?? '',
      created_at: source.created_at ?? '',
      email: source.email ?? '',
      telephone: source.telephone ?? '',
      groups: [...(source.groups ?? [])],
      without_group_only: source.without_group_only ?? false,
      level_from: source.level_from ?? null,
      level_to: source.level_to ?? null,
    })

    const filters = reactive(makeLocalFilters(storedFilters.value))

    const filterStringLabels = {
      name: 'ФИО',
      job_title: 'Должность',
      groups: 'Группы',
      level_from: 'Совпадение с профилем',
      level_to: 'Совпадение с профилем',
    }

    const buildInputLineString = () => {
      currentFiltersLine.value = ''

      const parts = []

      if (filters.name) {
        parts.push(`ФИО: ${filters.name}`)
      }

      if (filters.job_title) {
        parts.push(`Должность: ${filters.job_title}`)
      }

      if (filters.groups?.length) {
        const groupNames = filters.groups
            .map((groupId) => groups.value.find((group) => group.id === groupId)?.name)
            .filter(Boolean)
            .join(', ')

        if (groupNames) {
          parts.push(`Группы: ${groupNames}`)
        }
      }

      if (filters.level_from || filters.level_to) {
        const levelParts = []

        if (filters.level_from) {
          levelParts.push(`от ${filters.level_from}`)
        }

        if (filters.level_to) {
          levelParts.push(`до ${filters.level_to}`)
        }

        parts.push(`Совпадение с профилем: ${levelParts.join(' ')}`)
      }

      currentFiltersLine.value = parts.join(', ')
    }

    const updateFilters = () => {
      buildInputLineString()

      store.dispatch('users/setUserFilters', {
        filters: {
          ...toRaw(filters),
          groups: [...(filters.groups ?? [])],
        },
        filterString: currentFiltersLine.value,
      })

      closeForm()
    }

    const closeForm = () => {
      context.emit('close')
    }

    watch(storedFilters, () => {
      Object.assign(filters, makeLocalFilters(storedFilters.value))
    })

    return {
      filters,
      updateFilters,
      closeForm,
      groups,
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.ant-form-item-label) {
  padding-bottom: 4px !important;
}

:deep(.ant-form-item) {
  margin-bottom: 12px;
}

.range-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
</style>